import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=fe52f01e&scoped=true&"
import script from "./Expense.vue?vue&type=script&lang=js&"
export * from "./Expense.vue?vue&type=script&lang=js&"
import style0 from "./Expense.vue?vue&type=style&index=0&id=fe52f01e&lang=less&scoped=true&"
import style1 from "./Expense.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe52f01e",
  null
  
)

export default component.exports